import { render, staticRenderFns } from "./turnstile-widget.vue?vue&type=template&id=0a456c2e&scoped=true"
import script from "./turnstile-widget.vue?vue&type=script&lang=js"
export * from "./turnstile-widget.vue?vue&type=script&lang=js"
import style0 from "./turnstile-widget.vue?vue&type=style&index=0&id=0a456c2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a456c2e",
  null
  
)

export default component.exports